<template>
	<Modal v-model="modal.ifShow" :title="modal.Title" width="40%" :mask-closable="false" :closable="false">
		<!--会员添加修改-->
		<Form label-position="right" v-if="modal.type=='add'||modal.type=='up'" ref="groupMemberForm"
			:model="groupMemberInfo" :label-width="90">
			<Row :gutter="24" type="flex" align="bottom">
				<Col :span="12">
				<FormItem label="上传头像:" prop="Member">
					<div style="float: right;width: 100%;">
						<Upload name="UpFile" :show-upload-list="false" :format="['jpg','jpeg','png']"
							:action="uploadImageUrl" :headers="upHeader" :on-error="uploadError"
							:on-success="uploadSuccess">
							<Button icon="ios-cloud-upload-outline">点击上传头像</Button>
						</Upload>
					</div>
				</FormItem>
				</Col>
				<Col :span="12">
				<FormItem prop="Member">
					<div style="float: right;width: 100%;text-align: center;" class="memberStyle">
						<Avatar size="large" :src="groupMemberInfo.Headimgurl" />
					</div>
				</FormItem>
				</Col>
			</Row>
			<Row :gutter="24">
				<Col :span="12">
				<FormItem label="会员名称:" prop="GroupName">
					<Input :disabled="modal.canInput" v-model="groupMemberInfo.GroupName" placeholder="输入会员名称"></Input>
				</FormItem>
				</Col>
				<Col :span="12">
				<FormItem label="手机号码" prop="PhoneNo">
					<Input :disabled="modal.canInput" v-model="groupMemberInfo.PhoneNo" placeholder="输入手机号码"></Input>
				</FormItem>
				</Col>
			</Row>
			<Row :gutter="24">
				<Col :span="12">
				<FormItem prop="StationList" label="限制场站:" :label-width="90">
					<Select filterable :max-tag-count='1' placeholder="限制场站" multiple v-model="groupMemberInfo.StationArray">
						<Option v-bind:key="itemIndex" v-for="(item,itemIndex) in StationList" :value="item.StationId">{{item.StationName}}</Option>
					</Select>
				</FormItem>
				</Col>
				<Col :span="12">
				<FormItem label="备注" prop="Remark">
					<Input :disabled="modal.canInput" v-model="groupMemberInfo.Remark" placeholder="备注"></Input>
				</FormItem>
				</Col>
			</Row>
			<!-- <Row :gutter="24">
				<Col :span="12">
				<FormItem label="建档人" prop="Creator">
					<Input :disabled='true' v-model="groupMemberInfo.Creator" placeholder="建档人"></Input>
				</FormItem>
				</Col>
				<Col :span="12">
				<FormItem label="建档时间" prop="CreateTime">
					<Input :disabled='true' v-model="groupMemberInfo.CreateTime" placeholder="建档时间"></Input>
				</FormItem>
				</Col>
			</Row> -->
			<!-- <Row :gutter="24">
				<Col :span="12">
				<FormItem label="修改人" prop="Modifier">
					<Input :disabled='true' v-model="groupMemberInfo.Modifier" placeholder="修改人"></Input>
				</FormItem>
				</Col>
				<Col :span="12">
				<FormItem label="修改时间" prop="ModifyTime">
					<Input :disabled='true' v-model="groupMemberInfo.ModifyTime" placeholder="修改时间"></Input>
				</FormItem>
				</Col>
			</Row> -->
		</Form>
		<div v-if="modal.type=='add'" slot="footer">
			<Button type="warning" size="large" @click="modalOk('cancle')">取消</Button>
			<Button type="success" size="large" @click="modalOk('add')">添加</Button>
		</div>
		<div v-if="modal.type=='up'" slot="footer">
			<Button type="warning" @click="modalOk('cancle')" size="large">取消</Button>
			<Button type="success" @click="modalOk('up')" size="large">修改</Button>
		</div>
	</Modal>
</template>

<script>
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import webapi from '../../../../webapi';
	export default {
		data() {
			return {
				uploadImageUrl: webapi.base_api_url + '/Common/UploadImage',
				upHeader: {
					'Authorization': "Bearer " + encodeURIComponent(localStorage.AccessToken)
				},
				//model 控制 会员
				modal: {
					Title: "会员添加",
					type: "add",
					ifShow: false,
					canInput: false
				},
				//添加会员model
				groupMemberInfo: {
					GroupName: "",
					PhoneNo: "",
					Remark: "",
					StationArray: [],
					Headimgurl: "",
				},
			}
		},
		computed: {
			//直接选属性
			...mapState({
				StationList: 'Stations'
			})
		},
		methods: {
			//打开新增会员
			openAddGroupMember: function(type, upGroup) {
				const _this = this;
				if (type == "add") {
					_this.modal.Title = "集团会员添加";
					_this.modal.type = "add";
					delete _this.groupMemberInfo.GroupId;
					_this.$refs.groupMemberForm.resetFields()
				} else if (type == "修改") {
					_this.modal.Title = "集团会员修改";
					_this.modal.type = "up";
					console.log(upGroup)
					_this.groupMemberInfo = upGroup[0];
				}
				_this.modal.ifShow = true
			},
			//model操作
			modalOk: function(type) {
				const _this = this
				switch (type) {
					case 'cancle':
						_this.modal.ifShow = false
						break;
					case 'add':
						_this.modal.ifShow = true
						_this.addGroupMember();
						break;
					case 'up':
						_this.modal.ifShow = true
						_this.upGroupMember();
						break;
					default:
						break;
				}
			},

			//添加会员
			addGroupMember: function() {
				const _this = this;
				_this.groupMemberInfo.StationList = JSON.stringify(_this.groupMemberInfo.StationArray)
				let parms = _this.groupMemberInfo
				_this.$axios.post(webapi.base_api_url + "/Member/AddGroupMember", parms, {}).then(res => {
					console.log("新增集团会员")
					console.log(res.data)
					if (res.data.Code == 0) {
						this.$Message.success('集团会员添加成功');
						_this.handleSubmit();
						_this.modalOk("cancle")
					} else {
						this.$Message.error(res.data.Msg + "---" + res.data.Data);
					}
				})
			},
			//修改会员
			upGroupMember: function() {
				const _this = this;
				_this.groupMemberInfo.StationList = JSON.stringify(_this.groupMemberInfo.StationArray)
				let parms = _this.groupMemberInfo
				_this.$axios.post(webapi.base_api_url + "/Member/ModifyGroupMember", parms, {}).then(res => {
					console.log("修改集团会员")
					console.log(res.data)
					if (res.data.Code == 0) {
						this.$Message.success('修改集团会员成功');
						_this.handleSubmit();
						_this.modalOk("cancle")
					} else {
						this.$Message.error(res.data.Msg + "---" + res.data.Data);
					}
				})
			},
			//会员注销
			deleteGroupMember: function(GroupId) {
				const _this = this;
				let parms = {
					GroupId: GroupId
				};
				_this.$axios.post(webapi.base_api_url + "/Member/DeleteGroupMember", parms, {}).then(res => {
					console.log("注销集团会员")
					console.log(res.data)
					if (res.data.Code == 0) {
						this.$Message.success('注销集团会员成功');
						_this.handleSubmit();
					} else {
						this.$Message.error('注销失败');
						this.$Message.error(res.data.Msg + "---" + res.data.Data);
					}
				})
			},
			//上传文件
			uploadSuccess: function(response, file, fileList) {
				console.log("上传文件成功")
				this.groupMemberInfo.Headimgurl = response.Data.List[0];
			},
			//上传文件error
			uploadError: function(response, file, fileList) {
				this.$Message.error("上传文件失败")
			},
			handleSubmit: function() {
				this.$emit("handleSubmit")
			},
		}
	}
</script>

<style>
</style>
